import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { User } from '../../types';

export const authSlice = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/api/auth' }),
    endpoints: (builder) => ({
        getUserData: builder.query<User, void>({
            query: () => '/get-user-data',
        }),
    }),
});

export const { useGetUserDataQuery } = authSlice;
